import { IS_MVP } from '@services/servers';

export const isMvpVersion = () => {
    return IS_MVP;
}
